<template>
  <div
    class="rounded relative flex cursor-pointer flex-col gap-sm bg-white p-sm"
    v-on:click="click(arende)"
    :class="{ 'border-thick': isRecent, 'border-black': isRecent }"
  >
    <LabeledText label="Kontaktorsak" :text="arende.rubrik" />
    <div class="flex flex-row justify-between">
      <ArendeIdDate class="pt-3xs" :id="arende.id" :date="date" />
      <CopyToClipboard
        class="mb-none"
        v-if="props.arende?.id"
        text="Kopiera ärendelänk"
        :data="props.url"
        @click.stop.prevent=""
      />
    </div>
    <ArendeStatusPill :isOpen="props.arende.isOpen" />
  </div>
</template>
<script setup lang="ts">
import { DateTime } from "luxon";
import { computed, inject } from "vue";

import CopyToClipboard from "@/components/ui/CopyToClipboard.vue";
import type { SimpleArende } from "@/types/simpleArende";
import { standardDateFormat } from "@/common/formatters";

import LabeledText from "./LabeledText.vue";
import ArendeIdDate from "./ArendeIdDate.vue";
import ArendeStatusPill from "./ArendeStatusPill.vue";

const ARENDE_IS_RECENT_MINUTES = 10;

const props = defineProps<{
  arende: SimpleArende;
  url: string;
}>();

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const click = inject("openArende", (_arende: SimpleArende) => {});

const date = computed(() => {
  return props.arende.updatedAt
    ? DateTime.fromJSDate(props.arende.updatedAt).toFormat(standardDateFormat)
    : "";
});

const isRecent = props.arende.updatedAt
  ? Math.abs(
      DateTime.fromJSDate(props.arende.updatedAt).diff(
        DateTime.now(),
        "minutes",
      ).minutes,
    ) < ARENDE_IS_RECENT_MINUTES
  : false;
</script>
